import React, { createContext, useContext } from "react"

import {
  AttachmentType,
  ProductInformation
} from "shared/types/__generated__/graphql"

export interface ProductPositionFormProductInformationContextValue {
  productInformation?: ProductInformation | null
  isLoadingProductInformation?: boolean
  getFilesCallback?: (args: {
    productType: string
    parentProductType?: string
  }) => AttachmentType[] | undefined
}

const ProductPositionFormProductInformationContext = createContext<
  ProductPositionFormProductInformationContextValue | undefined
>(undefined)

export interface ProductPositionFormProductInformationProviderProps {
  value: ProductPositionFormProductInformationContextValue
  children: React.ReactNode
}

export const ProductPositionFormProductInformationProvider = React.memo(
  ({ value, children }: ProductPositionFormProductInformationProviderProps) => (
    <ProductPositionFormProductInformationContext.Provider value={value}>
      {children}
    </ProductPositionFormProductInformationContext.Provider>
  )
)

export function useProductPositionFormProductInformationContext(): ProductPositionFormProductInformationContextValue {
  const context = useContext(ProductPositionFormProductInformationContext)
  if (!context) {
    throw new Error(
      "useProductPositionFormProductInformationContext must be used within a ProductPositionFormProductInformationProvider"
    )
  }
  return context
}
